import MessageBox from './MessageBox';
import React from 'react';

interface EmailUpdateSuccessProps {
  admin: boolean;
  email: string;
  unlinkMessage?: string;
}

const EmailUpdateSuccess = (props: EmailUpdateSuccessProps) => {
  return (
    <MessageBox
      header="Excellent news!"
      message={`${
        props.admin ? `User's` : 'Your'
      } email address has been successfully updated to ${props.email}${
        props.unlinkMessage
      }.`}
    />
  );
};

export default EmailUpdateSuccess;
